import { Icon } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'

import { Course } from 'types/data'

import { useAboutSectionVideo } from '../AboutSectionVideoContext'
import { TrailerProps, SampleProps } from '../types'
import { trackSampleVideoPlay, trackTrailerVideoPlay } from '../events'

import classes from './styles.module.scss'

interface VideoButtonsProps {
  trailer?: TrailerProps
  sample?: SampleProps
  series: Course
}

export const VideoButtons = ({
  trailer,
  sample,
  series,
}: VideoButtonsProps) => {
  const { t } = useTranslation('@mc/next')
  const { toggleVideo, isPlaying, videoId, mediaUuid, pageType } =
    useAboutSectionVideo()

  const getPlayingIcon = (id: string | undefined, uuid: string | undefined) =>
    isPlaying && (videoId === id || mediaUuid === uuid)
      ? 'pause'
      : 'play-circle'

  return (
    <>
      {(trailer?.brightcoveVideoId || trailer?.mediaUuid) && (
        <button
          className='mc-accordion__item d-flex mc-p-4 mc-mb-1 align-items-center mc-corners--sm mc-overflow--hidden'
          onClick={() => {
            toggleVideo(trailer.brightcoveVideoId, trailer.mediaUuid)
            trackTrailerVideoPlay({
              pageType,
              slug: series.slug,
              title: series.title,
              brightcoveVideoId: series.brightcoveVideoId,
              mediaUuid: series.mediaUuid,
            })
          }}
        >
          <Icon
            kind={getPlayingIcon(trailer.brightcoveVideoId, trailer.mediaUuid)}
            className={`${classes.playIcon} mc-mr-3 mc-icon--3`}
          />
          {t('series.details.trailer')}
        </button>
      )}

      {(sample?.brightcoveVideoId || sample?.mediaUuid) && (
        <button
          className='mc-accordion__item d-flex mc-p-4 mc-mb-1 align-items-center mc-corners--sm mc-overflow--hidden'
          onClick={() => {
            toggleVideo(sample.brightcoveVideoId, sample.mediaUuid)
            trackSampleVideoPlay({
              pageType,
              slug: series.slug,
              title: series.title,
              brightcoveVideoId: series.sample?.brightcoveVideoId,
              mediaUuid: series.sample?.mediaUuid,
            })
          }}
        >
          <Icon
            kind={getPlayingIcon(sample.brightcoveVideoId, sample.mediaUuid)}
            className={`${classes.playIcon} mc-mr-3 mc-icon--3`}
          />
          {t('series.details.sample')}
        </button>
      )}
    </>
  )
}
